import {
    Alert,
    Box,
    Button,
    Card,
    CircularProgress,
    Collapse,
    Grid,
    Stack,
    Typography,
} from "@mui/material";
import { Formik } from "formik";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import DefaultApiService from "../../../infrastructure/api/default";
import { ReactComponent as InProgress } from "../../assets/icons/in-progress.svg";
import FormItem from "./FormItem";

// const validationSchema = Yup.object().shape({
//   adminComment: Yup.string().required("لطفا این فیلد را پر کنید."),
// });

const RequestStep = ({
  step,
  activeStep,
  index,
  data,
  workflowV2Summary,
  setShownStep,
  isViewOnly,
  onNavigateToListPage,
  onUpdateActiveStep,
  onOpenContractorModal, // اضافه شد
  onOpenPaymentModal, // اضافه شد
  selectedPackageData, // اضافه شد
  selectedPaymentData, // اضافه شد
  source, // اضافه شد
  baseUrl, // برای نمایش فایل‌های آپلود شده
}) => {
  let navigate = useNavigate();

  // گرفتن requestId از data.request.id یا از URL
  const requestId = data?.request?.id || null;
  const { stepFormData } = step;
  const [state, setState] = useState({
    submitButtonAction: null,
  });

  const handleFormItemButtonClick = (fieldKey) => {
    if (fieldKey === "contractorSelector") {
      onOpenContractorModal?.();
    }

    if (fieldKey === "paymentSelector") {
      onOpenPaymentModal?.();
    }
  };

  const onRenderRequestStatue = () => {
    switch (data?.request?.requestConfirm) {
      case "NotChecked":
        return "";
      case "Canceled":
        return (
          <Typography color={"secondary"}>
            (درخواست در این مرحله رد شده است)
          </Typography>
        );
      case "InProcess":
        return <Typography color={"primary"}>(مرحله کنونی)</Typography>;
      case "Completed":
        return "";
      default:
        return "";
    }
  };

  const handleSubmitButtonState = (action) => {
    setState((old) => ({ ...old, submitButtonAction: action }));
  };

  // Submit Action
  const onSubmit = async (formValue, { setSubmitting, resetForm }) => {
    if (state.submitButtonAction) {
      // تبدیل paymentKind به عدد (enum value) اگر string است
      const processedFormValue = { ...formValue };
      if (processedFormValue.paymentKind !== undefined) {
        processedFormValue.paymentKind = parseInt(processedFormValue.paymentKind, 10) || processedFormValue.paymentKind;
      }

      // فیلتر کردن مقادیر نامعتبر برای فایل‌ها
      // اگر contractFileUrl برابر "/" یا مقدار نامعتبر است، آن را null یا empty string کنیم
      if (processedFormValue.contractFileUrl === "/" ||
        processedFormValue.contractFileUrl === "" ||
        !processedFormValue.contractFileUrl) {
        processedFormValue.contractFileUrl = null;
      }

      // فیلتر کردن paymentFileUrl
      // فقط اگر مقدار دقیقاً "/" یا خالی باشد، آن را null می‌کنیم
      // اگر مقدار معتبری دارد (مثل "/files/..." یا "files/...")، آن را نگه می‌داریم
      if (processedFormValue.paymentFileUrl === "/" ||
        processedFormValue.paymentFileUrl === "" ||
        (processedFormValue.paymentFileUrl && processedFormValue.paymentFileUrl.trim() === "/")) {
        processedFormValue.paymentFileUrl = null;
      }

      // Debug: بررسی مقدار paymentFileUrl قبل از ارسال
      if (processedFormValue.paymentFileUrl) {
        console.log("🔍 paymentFileUrl before send:", processedFormValue.paymentFileUrl);
      }

      // تبدیل paymentSelector به paymentKind
      // اگر paymentId وجود دارد، از آن استفاده می‌کنیم (اولویت اول)
      if (processedFormValue.paymentId) {
        processedFormValue.paymentKind = parseInt(processedFormValue.paymentId, 10);
      }
      // اگر paymentKind وجود ندارد و paymentSelector وجود دارد، از mapping استفاده می‌کنیم
      else if (processedFormValue.paymentSelector && !processedFormValue.paymentKind) {
        const paymentMapping = {
          "پرداخت آنلاین": 1,
          "واریز به حساب": 2,
          "معرفی به پلتفرم وام": 3,
          "معرفی به بانک": 4
        };
        processedFormValue.paymentKind = paymentMapping[processedFormValue.paymentSelector] || 1;
      }

      // اطمینان از اینکه paymentFileUrl از processedFormValue override نشود
      const finalFormValues = {
        ...initialValues, // ابتدا مقادیر اولیه (شامل فیلدهای hidden)
        ...processedFormValue, // سپس مقادیر فرم (که فیلدهای ویرایش شده را override می‌کند)
        requestId,
      };

      // اگر paymentFileUrl در processedFormValue وجود دارد و معتبر است، آن را نگه می‌داریم
      if (processedFormValue.paymentFileUrl &&
        processedFormValue.paymentFileUrl !== "/" &&
        processedFormValue.paymentFileUrl.trim() !== "/") {
        finalFormValues.paymentFileUrl = processedFormValue.paymentFileUrl;
      }

      // Debug: بررسی مقدار نهایی paymentFileUrl
      console.log("🔍 Final paymentFileUrl:", finalFormValues.paymentFileUrl);
      console.log("🔍 All form values:", finalFormValues);

      onCallAction({
        action: state.submitButtonAction,
        setSubmitting,
        formValues: finalFormValues,
      });
    }
  };

  const onCallAction = async ({ action, setSubmitting, formValues }) => {
    if (action) {
      // جلوگیری از فراخوانی دوباره اگر در حال اجراست
      if (state[action?.id]) {
        console.warn(`Action ${action?.id} is already in progress. Preventing duplicate call.`);
        return;
      }

      setSubmitting?.(true);
      setState((old) => ({ ...old, [action?.id]: true }));
      try {
        const res = await DefaultApiService.postApi(action?.url, formValues);
        if (res.isSuccess) {
          toast.success(res.message);
          setSubmitting?.(false);
          // ری‌دایرکت به صفحه لیست درخواست‌ها بر اساس نقش کاربر
          let redirectPath = "/SLN/Customer/Requests"; // پیش‌فرض برای Customer
          if (source === "Supervisor") {
            redirectPath = "/SLN/Supervisor/InProcessRequest";
          } else if (source === "SolarentOperator") {
            redirectPath = "/SLN/SolarentOperator/InProcessRequest";
          } else if (source === "Contractor") {
            redirectPath = "/SLN/Contractor/InProcessRequest";
          }
          navigate(redirectPath);
        } else {
          toast.error(res.message);
        }
        setState((old) => ({ ...old, [action?.id]: false }));
      } catch (error) {
        toast.error(error?.response?.data?.message || "خطایی رخ داده است.");
        setState((old) => ({ ...old, [action?.id]: false }));
        setSubmitting?.(false);
      }
    }
  };

  const validationSchema = useMemo(() => {
    if (!stepFormData?.formItems?.length) return Yup.object().shape({});

    const shape = stepFormData.formItems.reduce((acc, item) => {
      if (!item?.key) return acc;

      // فقط اگر فیلد required هست
      if (item.isRequired && item.isVisible && !item.isReadOnly) {
        let validator = Yup.string().required(
          item.isRequiredText || "این فیلد الزامی است."
        );

        // اگر نوع فیلد checkbox یا number باشه می‌تونی نوعش رو تغییر بدی
        if (item.type === "number") {
          validator = Yup.number()
            .typeError("عدد وارد کنید")
            .required(item.isRequiredText || "این فیلد الزامی است.");
        }
        // else if (item.type === "checkbox") {
        //   validator = Yup.boolean().oneOf(
        //     [true],
        //     item.isRequiredText || "این فیلد باید انتخاب شود"
        //   );
        // }

        acc[item.key] = validator;
      }

      return acc;
    }, {});

    return Yup.object().shape(shape);
  }, [step]);

  const initialValues = useMemo(() => {
    if (!stepFormData?.formItems?.length) return {};
    const finalData = {};

    for (let i = 0; i < stepFormData.formItems.length; i++) {
      const item = stepFormData.formItems[i];

      // اضافه کردن همه فیلدها به initialValues، حتی اگر initValue ندارند
      if (item?.initValue !== undefined && item?.initValue !== null && item.initValue !== "") {
        // برای checkbox، مقدار را به boolean تبدیل کن
        if (item.type === "checkbox") {
          finalData[item.key] =
            item.initValue === "true" || item.initValue === true;
        } else {
          // برای فیلدهای عددی مثل id، requestId، companyId، مقدار را به عدد تبدیل کن
          if (item.key === "id" || item.key === "Id" ||
            item.key === "requestId" || item.key === "RequestId" ||
            item.key === "companyId" || item.key === "CompanyId") {
            const numValue = parseInt(item.initValue, 10);
            finalData[item.key] = isNaN(numValue) ? 0 : numValue;
          } else {
            finalData[item.key] = item.initValue;
          }
        }
      } else {
        // برای فیلدهایی که initValue ندارند، مقدار پیش‌فرض می‌گذاریم
        if (item.type === "checkbox") {
          finalData[item.key] = false;
        } else if (item.inputType === "date" || item.inputType === "datetime") {
          finalData[item.key] = null;
        } else if (item.type === "select") {
          // برای select fields، اگر options موجود هستند، اولین مقدار را بگیر
          if (item.options && item.options.length > 0) {
            finalData[item.key] = item.options[0].value;
          } else {
            finalData[item.key] = "";
          }
        } else {
          // برای فیلدهای عددی مثل id، requestId، companyId، مقدار پیش‌فرض 0 است
          if (item.key === "id" || item.key === "Id" ||
            item.key === "requestId" || item.key === "RequestId" ||
            item.key === "companyId" || item.key === "CompanyId") {
            finalData[item.key] = 0;
          } else {
            finalData[item.key] = "";
          }
        }
      }
    }

    // اگر قیمت انتخاب شده موجود است، فیلد price را با آن پر کن (غیر از مشتری)
    if (selectedPackageData && source !== "Customer") {
      if (selectedPackageData.packageId !== undefined) {
        finalData["packageId"] = selectedPackageData.packageId;
      }
      if (selectedPackageData.contractorInfoId !== undefined) {
        finalData["contractorInfoId"] = selectedPackageData.contractorInfoId;
      }
      if (selectedPackageData.price !== undefined) {
        finalData["price"] = selectedPackageData.price;
      }
      if (selectedPackageData.packageTitle !== undefined) {
        finalData["packageTitle"] = selectedPackageData.packageTitle;
      }
    }

    // اگر اطلاعات پرداخت انتخاب شده موجود است
    if (selectedPaymentData) {
      if (selectedPaymentData.paymentId !== undefined) {
        // مقدار enum برای PaymentKind (1, 2, 3, یا 4) - تبدیل به عدد
        const paymentKindValue = typeof selectedPaymentData.paymentId === 'string'
          ? parseInt(selectedPaymentData.paymentId, 10)
          : selectedPaymentData.paymentId;
        finalData["paymentKind"] = paymentKindValue;
        finalData["paymentId"] = paymentKindValue;
      }
      if (
        selectedPaymentData.contractorInfoId !== undefined &&
        source !== "Customer"
      ) {
        finalData["paymentContractorId"] = selectedPaymentData.contractorInfoId;
      }
      if (selectedPaymentData.paymentTitle !== undefined) {
        finalData["paymentTitle"] = selectedPaymentData.paymentTitle;
        // همچنین برای dropdown/select های دیگر
        finalData["paymentMethod"] = selectedPaymentData.paymentTitle;
        finalData["paymentSelector"] = selectedPaymentData.paymentTitle;
      }
    }

    // تنظیم requestId اگر از initialValues نیامده باشد
    if (!finalData["requestId"] && requestId) {
      finalData["requestId"] = requestId;
    }

    // برای فیلدهای map، باید XPoint و YPoint در initialValues باشند
    // اگر فیلد MapLocation وجود دارد اما XPoint و YPoint در initialValues نیستند،
    // باید آنها را از سایر فیلدها بگیریم
    const mapLocationItem = stepFormData?.formItems?.find(item => item.type === "map" || item.key === "MapLocation");
    if (mapLocationItem) {
      // اگر XPoint و YPoint در formItems هستند، آنها را به initialValues اضافه کن
      const xPointItem = stepFormData?.formItems?.find(item => item.key === "XPoint" || item.key === "xPoint");
      const yPointItem = stepFormData?.formItems?.find(item => item.key === "YPoint" || item.key === "yPoint");

      if (xPointItem && xPointItem.initValue !== undefined && xPointItem.initValue !== null) {
        finalData["XPoint"] = xPointItem.initValue;
        finalData["xPoint"] = xPointItem.initValue;
      }
      if (yPointItem && yPointItem.initValue !== undefined && yPointItem.initValue !== null) {
        finalData["YPoint"] = yPointItem.initValue;
        finalData["yPoint"] = yPointItem.initValue;
      }
    }

    return finalData;
  }, [step, selectedPackageData, selectedPaymentData]);

  const currentWorkflowStage =
    workflowV2Summary?.currentWorkflowV2Stage ||
    workflowV2Summary?.CurrentWorkflowV2Stage ||
    "";
  const hasWorkflowV2 =
    workflowV2Summary?.hasWorkflowV2 === true ||
    workflowV2Summary?.HasWorkflowV2 === true;

  const stageRank = (stage) => {
    const map = {
      NoPlan: 0,
      ExecutionPlanDraft: 1,
      ExecutionPlanApproved: 2,
      VisitAssigned: 3,
      VisitAccepted: 4,
      VisitScheduled: 5,
      VisitCompleted: 6,
      QuoteDraft: 7,
      QuoteSubmitted: 8,
      QuoteApproved: 9,
      ContractGenerated: 10,
      ContractAccepted: 11,
      FinalApprovalPending: 12,
      FinalApprovalApproved: 13,
      ExecutionActivated: 14,
    };
    return map[String(stage || "")] ?? -1;
  };

  const isLegacyVisitStep =
    typeof step?.stepTitle === "string" &&
    (step.stepTitle.includes("تعیین زمان بازدید") ||
      step.stepTitle.includes("انتخاب بازدیدکننده") ||
      step.stepTitle.includes("بازدید"));

  const isV2PastVisitAcceptance =
    hasWorkflowV2 && stageRank(currentWorkflowStage) >= stageRank("VisitAccepted");
  const isV2VisitCompletedOrAbove =
    hasWorkflowV2 && stageRank(currentWorkflowStage) >= stageRank("VisitCompleted");
  const isV2QuoteSubmittedOrAbove =
    hasWorkflowV2 && stageRank(currentWorkflowStage) >= stageRank("QuoteSubmitted");

  const isLegacyContractUploadStep =
    typeof step?.stepTitle === "string" &&
    (step.stepTitle.includes("بارگذاری قرارداد") ||
      step.stepTitle.includes("آپلود قرارداد") ||
      (step.stepTitle.includes("قرارداد") && step.stepTitle.includes("آپلود")));

  const shouldGuardLegacyContractCard =
    source === "SolarentOperator" &&
    isLegacyContractUploadStep &&
    hasWorkflowV2 &&
    stageRank(currentWorkflowStage) >= stageRank("QuoteApproved");

  const shouldGuardLegacyVisitCard =
    source === "SolarentOperator" &&
    isLegacyVisitStep &&
    (isV2PastVisitAcceptance || isV2QuoteSubmittedOrAbove);

  const shouldGuardLegacyStepCard =
    shouldGuardLegacyVisitCard || shouldGuardLegacyContractCard;

  const suppressCustomerGenericWaiting =
    source === "Customer" &&
    hasWorkflowV2 &&
    index === activeStep &&
    (currentWorkflowStage === "CustomerPriceApproved" ||
      currentWorkflowStage === "CustomerPriceAccepted");

  // console.log("validationSchema", validationSchema);
  // console.log("step?.formItems", step?.formItems);
  // console.log("state", state);

  return (
    <Card
      variant="outlined"
      sx={{
        p: 2.5,
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1 }}>
        <Typography variant="h6" fontWeight={700} color="primary.main">
          {step.stepTitle}
        </Typography>
        {index === activeStep && onRenderRequestStatue()}
      </Box>

      {shouldGuardLegacyStepCard ? (
        <Alert severity={isV2VisitCompletedOrAbove ? "success" : "info"} sx={{ mb: 2 }}>
          {shouldGuardLegacyContractCard ? (
            <>
              قرارداد اجرا از مسیر <strong>WorkflowV2</strong> (پیشنهاد قیمت تأیید‌شده) مدیریت
              می‌شود. بارگذاری قرارداد legacy غیرفعال است — از پرونده پروژه (ProjectWorkspace)
              یا بخش پیشنهاد قیمت اقدام کنید.
            </>
          ) : isV2QuoteSubmittedOrAbove ? (
            <>
              این پروژه از مسیر <strong>WorkflowV2</strong> مدیریت می‌شود. وضعیت بازدید و
              پیشنهاد قیمت را در بخش «روند اجرای پروژه (WorkflowV2)» مشاهده کنید.
            </>
          ) : isV2VisitCompletedOrAbove ? (
            <>
              بازدید از مسیر <strong>WorkflowV2</strong> تکمیل شده است. برای مشاهده جزئیات،
              از دکمه «مشاهده جزئیات بازدید» در بخش WorkflowV2 استفاده کنید.
            </>
          ) : (
            <>
              این پروژه از مسیر <strong>WorkflowV2</strong> مدیریت می‌شود. وضعیت بازدید را
              در بخش «روند اجرای پروژه (WorkflowV2)» مشاهده کنید.
            </>
          )}
        </Alert>
      ) : null}

      {/*{index === activeStep && step?.isShowModifyForm && !isViewOnly ? ( */}
      {!isViewOnly && !shouldGuardLegacyStepCard ? (
        <Grid container spacing={3}>
          {stepFormData?.formItems?.length ? (
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize={true}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  submitForm,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => {
                  const onMakeFormikVariable = (name) => ({
                    name: name,
                    fullWidth: true,
                    value: values[name],
                    error: errors[name], //&& touched[name]
                    helperText: errors[name] ? errors[name] : "",
                    variant: "outlined",
                  });

                  // console.log("error", errors);
                  // console.log("touched", touched);

                  return (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={3}>
                        {stepFormData?.formItems
                          ?.sort(
                            (a, b) => (a?.priority ?? 0) - (b?.priority ?? 0)
                          )
                          .filter((x) => {
                            // فیلتر کردن فیلدهای مخفی
                            if (x.isVisible === false) return false;
                            // فیلتر کردن فیلدهایی که label ندارند یا خالی هستند
                            if (!x.label || x.label.trim() === "" || x.label === "FormItem") return false;
                            // فیلتر کردن فیلدهایی که key ندارند
                            if (!x.key) return false;
                            return true;
                          })
                          .map((form) => (
                            <Grid
                              item
                              xs={form?.size?.xs || 12}
                              sm={form?.size?.sm || 12}
                              md={form?.size?.md || 6}
                              lg={form?.size?.lg || 4}
                              key={form.key}
                            >
                              <FormItem
                                form={form}
                                values={values}
                                inputProps={onMakeFormikVariable(form.key)}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                onButtonClick={handleFormItemButtonClick}
                                baseUrl={baseUrl}
                              />
                            </Grid>
                          ))}

                        {stepFormData?.actions?.length ? (
                          <Grid
                            item
                            xs={12}
                            md={12}
                            container
                            justifyContent={"flex-end"}
                            gap={1}
                          >
                            {stepFormData.actions
                              .sort(
                                (a, b) =>
                                  (b?.priority ?? 0) - (a?.priority ?? 0)
                              )
                              .map((action) => (
                                <Button
                                  key={action.id}
                                  disabled={isSubmitting || state?.[action.id]}
                                  variant={
                                    action?.variant?.toLowerCase() || "text"
                                  }
                                  onClick={() => {
                                    if (action?.isFormValidation) {
                                      handleSubmitButtonState(action);
                                    } else {
                                      onCallAction({
                                        action,
                                        formValues: initialValues,
                                      });
                                    }
                                  }}
                                  size="large"
                                  type={
                                    action?.isFormValidation
                                      ? "submit"
                                      : "button"
                                  }
                                  color={
                                    action.color?.toLowerCase() || "primary"
                                  }
                                >
                                  {state?.[action.id] && (
                                    <CircularProgress
                                      size={16}
                                      color="primary"
                                      sx={{ mr: 1 }}
                                    />
                                  )}
                                  {action.title}
                                </Button>
                              ))}
                          </Grid>
                        ) : null}
                      </Grid>
                    </form>
                  );
                }}
              </Formik>
            </Grid>
          ) : suppressCustomerGenericWaiting ? null : (
            <Grid item xs={12}>
              <InProgress width={200} height={200} />
              <Typography variant="body1" fontWeight={600}>
                {index === activeStep
                  ? isViewOnly
                    ? "درخواست شما در حال بررسی است..."
                    : "درخواست  در حال بررسی است..."
                  : "درخواست شما بررسی شد."}
              </Typography>
            </Grid>
          )}
        </Grid>
      ) : (
        <Collapse
          in={step.collapse}
          timeout="auto"
          unmountOnExit
          sx={{ width: "100%" }}
        >
          <Grid container spacing={3}>
            {suppressCustomerGenericWaiting ? null : (
            <Grid item xs={12}>
              <Stack
                sx={{
                  minHeight: 300,
                }}
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <InProgress width={200} height={200} />
                <Typography variant="body1" fontWeight={600}>
                  {index === activeStep
                    ? isViewOnly
                      ? "درخواست شما در حال بررسی است..."
                      : "درخواست  در حال بررسی است..."
                    : "درخواست شما بررسی شد."}
                </Typography>
              </Stack>
            </Grid>
            )}

            {index < activeStep ? (
              <Grid item xs={12} md={12} container justifyContent={"flex-end"}>
                <Button
                  variant="contained"
                  onClick={() => setShownStep((step) => step + 1)}
                  size="large"
                  type="submit"
                >
                  بعدی
                </Button>
              </Grid>
            ) : null}
          </Grid>
        </Collapse>
      )}
    </Card>
  );
};

export default RequestStep;
